import React from "react";
import { useState, useRef, useEffect } from "react";
import style from "./header_searchbar.module.css";
import { useNavigate } from "react-router-dom";
import { MdAttachMoney } from "react-icons/md";

const TopUpButton = () => {

	const navigate = useNavigate();
	const handleClick = () => {
        
            let url = "/TopUp";
            navigate(url);
        }
return (	
	<div>
	<button className = {style.searchButton} onClick = {handleClick}><MdAttachMoney className="icon" style={{ fontSize: "2rem" }} /></button>
	</div>
);

}

export default TopUpButton;
